import { IconButton } from '@upright/ui/common/generic/components/button';
import { Tooltip, type TooltipProps } from '@upright/ui/common/generic/components/tooltip';
import { type ButtonProps } from '@upright/ui/common/generic/components/button';
import { DistributedOmit } from 'type-fest';
import { InfoGlyph } from './InfoGlyph';

export function InfoTooltip({
  size,
  variant = 'text',
  ...tooltipProps
}: DistributedOmit<TooltipProps, 'children'> & Pick<ButtonProps, 'size' | 'variant'>) {
  return (
    <Tooltip {...tooltipProps}>
      <IconButton variant={variant} size={size} icon={InfoGlyph} aria-label="Info" />
    </Tooltip>
  );
}
